import React, { useEffect, useState } from "react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { Typeahead } from "react-bootstrap-typeahead";
import { ChoiceGroup } from "@fluentui/react/lib/ChoiceGroup";
import { getUserSummaryList } from "../../actions/UserAction";
import Header from "../../component/common/Header";

function ProbationCompletion() {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [probationType, setProbationType] = useState(null);
  const [selectedReviewingAuth, setSelectedReviewingAuth] = useState(null);
  const [selectedReportingAuth, setSelectedReportingAuth] = useState(null);

  const options = [
    { key: "A", text: "Joining" },
    { key: "B", text: "Promotion" },
  ];

  useEffect(() => {
    getUserList();
  }, []);

  async function getUserList() {
    try {
      const { result } = await getUserSummaryList();
      setEmployees(result);
    } catch (e) {
      setEmployees([]);
    }
  }

  function onEmployeeSelect(e) {
    setSelectedEmployee(e[0]);
  }

  function checkIfAllFilled() {
    return (
      selectedEmployee &&
      probationType &&
      selectedReviewingAuth &&
      selectedReportingAuth
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2 px-0">
          <Header />
        </div>
        <div className="col-md-10 mt-3 flex flex-col items-center p-3">
          <div className="w-full">
            <p className="text-center font-semibold">
              Confidential Report for Completion of Probation Period
            </p>
          </div>
          <div className="mt-3 w-full">
            <div>
              <Typeahead
                label="Select Employee"
                id="receipent"
                placeholder="Select Employee"
                required
                labelKey={(option) =>
                  `${option.name} - ${option.employeeNumber}`
                }
                onChange={onEmployeeSelect}
                value={""}
                options={employees}
              />
            </div>
            {selectedEmployee ? (
              <>
                <div className="flex justify-around mt-3">
                  <div>
                    <p className="text-base">
                      Designation:{" "}
                      <span className="font-semibold text-lg">
                        {selectedEmployee.designationName}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p className="text-base">
                      Code:{" "}
                      <span className="font-semibold text-lg">
                        {selectedEmployee.employeeNumber}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p className="text-base">
                      Division:{" "}
                      <span className="font-semibold text-lg">
                        {selectedEmployee.departmentName}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="mt-3 w-full flex justify-center items-center">
                  <div className="mr-3 w-2/5">
                    <ChoiceGroup
                      styles={{
                        root: {
                          display: "flex",
                          justifyContent: "space-between",
                        },
                        flexContainer: {
                          display: "flex",
                          flex: 1,
                          justifyContent: "space-around",
                        },
                      }}
                      defaultSelectedKey="B"
                      options={options}
                      onChange={(e, option) => setProbationType(option.text)}
                      label="Type:"
                      required={true}
                    />
                  </div>
                </div>
                <div className="mt-3 w-full flex items-center">
                  <div className="flex-1 flex flex-col mr-3">
                    <p className="mr-3">Reporting Authority (R01)</p>
                    <Typeahead
                      label="Reporting Authority (R01)"
                      id="reportingAuthority"
                      placeholder="Reporting Authority (R01)"
                      required
                      labelKey={(option) =>
                        `${option.name} - ${option.employeeNumber}`
                      }
                      onChange={(e) => setSelectedReportingAuth(e[0])}
                      value={""}
                      options={employees}
                    />
                  </div>
                  <div className="flex-1 flex flex-col mr-3">
                    <p className="mr-3">Reviewing Authority (R02)</p>
                    <Typeahead
                      label="Reviewing Authority (R02)"
                      id="reviewingAuthority"
                      placeholder="Reviewing Authority (R02)"
                      required
                      labelKey={(option) =>
                        `${option.name} - ${option.employeeNumber}`
                      }
                      onChange={(e) => setSelectedReviewingAuth(e[0])}
                      value={""}
                      options={employees}
                    />
                  </div>
                </div>
                <div className="mt-3 flex justify-center">
                  <PrimaryButton disabled={!checkIfAllFilled()}>
                    Submit
                  </PrimaryButton>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProbationCompletion;
